import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style18({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      activeItemNameKey="originalName"
      activeItemIconName="globe"
      onClick={onClick}
    />
  );
}
